import { ProtocolMode } from '@azure/msal-common';

import { WoEnv } from './types';

export const environment: WoEnv = {
  production: false,
  envName: 'DEV',
  backendHost: 'https://api-dev.wo.apps.issworld-test.com/ordering',
  oauth2: {
    clientId: '251309a1-ccfe-4e5f-bae4-e3f40613a266',
    scope: 'api://251309a1-ccfe-4e5f-bae4-e3f40613a266/WasteOnline.ReadWrite.All',
    authority: 'https://login.microsoftonline.com/9f030721-ff46-4ae0-948c-1a382c75452c',
    knownAuthorities: [],
    protocol: ProtocolMode.AAD,
  },
  keycloak: {
    url: 'https://dc-dev.sdc.apps.issworld-test.com',
    realm: 'wastemanager',
    clientId: 'wastemanager',
  },
  appName: 'ISS Smart Waste Control',
  mobileScheme: 'swc-iss-dev',
  support: {
    email: 'wast@dk.issworld.com',
    phone: '+45 44 44 60 70',
  },
  appInsights: {
    tenantId: '0e76efa8-a57a-46d8-a3f4-49f722a82f45',
    subscriptionId: 'edbef4c2-327b-4f27-9f43-bfa6a7acf518',
    resourceGroup: 'rg-gi-wo-dev',
    instanceName: 'wo-dev-app-insights',
  },
};
